var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('date-filter',{attrs:{"future":"","label":"Birth day"},model:{value:(_vm.dates),callback:function ($$v) {_vm.dates=$$v},expression:"dates"}})}
var staticRenderFns = []

export { render, staticRenderFns }